import { render, staticRenderFns } from "./EventRefundPolicy.vue?vue&type=template&id=4ac7a8b3&scoped=true"
import script from "./EventRefundPolicy.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventRefundPolicy.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventRefundPolicy.vue?vue&type=style&index=0&id=4ac7a8b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac7a8b3",
  null
  
)

export default component.exports